import { defineComponent as _defineComponent } from 'vue'
import { computed } from '../../../../../../adapter-vue';
import { TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import Icon from '../../../../../common/Icon.vue';
import copySVG from '../../../../../../assets/icon/msg-copy.svg';
import CopyManager from '../../../../utils/copy';
import { IOperationType, IOperation } from './type';

interface IProps {
  // handle the order and display of operations
  operations?: IOperationType[];
  // the content of the message to show, used to copy
  content?: string;
}

interface IEmits {
  // callback when operation is clicked
  (emitKey: 'onOperationClick', e: Event, key: IOperationType): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    operations: { default: () => [IOperationType.Copy] },
    content: null
  },
  emits: ["onOperationClick"],
  setup(__props: any, { emit: emits }: { emit: ({
  // callback when operation is clicked
  (emitKey: 'onOperationClick', e: Event, key: IOperationType): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { operations: IOperationType[], content?: string }




const defaultOperationConfig: Record<string, IOperation> = {
  [IOperationType.Copy]: {
    key: IOperationType.Copy,
    name: TUITranslateService.t('TUIChat.复制'),
    icon: copySVG,
    isDisabled: false,
    onClick: () => {
      CopyManager.copyTextOrHtml(props.content, 'text');
    },
  },
};

const operationConfig = computed(() => {
  return props.operations
    .map((key: IOperationType) => {
      const config = defaultOperationConfig?.[key];
      if (!config) {
        return;
      }
      return {
        ...config,
        onClick: (e: Event, key: IOperationType) => {
          if (config.isDisabled) {
            return;
          }
          config.onClick(e, key);
          emits('onOperationClick', e, key);
        },
      };
    })
    .filter(Boolean) as IOperation[];
});

return { __sfc: true,props, emits, defaultOperationConfig, operationConfig, Icon }
}

})